import {MARKET} from "../config";

export const getManualPrice = (year) => {
    switch (MARKET) {
        case 'en':
            return year ? 23.99 : 29.99;

        case 'pl':
            return year ? 41.99 : 51.99;

        case 'hu':
            return year ? 3999.99 : 4899.99;

        case 'ro':
            return year ? 50.99 : 62.99;

        case 'cz':
            return year ? 239 : 299;

        default:
            return year ? 9.99 : 12.49;
    }
};
